import BlockTitle from '@/src/components/Modules-revamp/BlockTitle';
import React from 'react';
import { Switch } from 'src/components/Antd';
import Wrapper from 'src/components/Modules-revamp/BlockWrapper';
import {
  Field, // itemWrapperErrorDisplayAdaptor
} from 'src/components/RcForm';
import {
  ProfileContentManagement,
  myAddress,
  profileContentManagement,
  subscriptionBuy,
  thirdPartyLogin,
  voucher,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorProfilePage-revamp/constant';
// import css from './css.module.less';
// import { sectionProps } from 'src/tools/constant';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
//import { getEditableStatus } from '../../SalesChannelEditorAllProductPage-revamp/util';
import { profileFields } from '../fields';
import { EPreviewSize } from 'src/types/common/SalesChannel';

// import { get } from 'lodash';

const PCM = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { breakpoint } = props;

  return (
    <Wrapper id={ProfileContentManagement} breakpoint={breakpoint}>
      <BlockTitle
        id={ProfileContentManagement}
        title={getI18n('general.hOCTitle.profileContentManagement')}
        breakpoint={breakpoint}
        onReset={() => {
          return;
        }}
        onCopy={() => props.handleOnSectionCopy(profileFields, breakpoint)}
        headerErrorDependencies={[]}
        validator={() => {
          return;
        }}
      />

      <Field shouldUpdate>
        {(props, meta, { getFieldValue }) => {
          const is_editable = breakpoint === EPreviewSize.WIDE;
          return (
            <Section
              {...{
                size: 'small',
                style: { paddingTop: 0 },
              }}>
              <ItemWrapper
                title={getI18n('salesChannelContent.index.displaythefollowing')}
                size='small'
              />
              <ItemWrapper
                size='small'
                title={getI18n('general.sider.subscriptionBuy')}
                rightPart={
                  <Field
                    name={[profileContentManagement, subscriptionBuy]}
                    valuePropName={'checked'}>
                    <Switch disabled={!is_editable} />
                  </Field>
                }
              />
              <ItemWrapper
                size='small'
                title={getI18n('general.sider.voucher')}
                rightPart={
                  <Field
                    name={[profileContentManagement, voucher]}
                    valuePropName={'checked'}>
                    <Switch disabled={!is_editable} />
                  </Field>
                }
              />
              <ItemWrapper
                size='small'
                title={getI18n('salesChannelContent.index.myAddress')}
                rightPart={
                  <Field
                    name={[profileContentManagement, myAddress]}
                    valuePropName={'checked'}>
                    <Switch disabled={!is_editable} />
                  </Field>
                }
              />
              <ItemWrapper
                size='small'
                title={getI18n('salesChannelContent.index.thirdPartyLogin')}
                rightPart={
                  <Field
                    name={[profileContentManagement, thirdPartyLogin]}
                    valuePropName={'checked'}>
                    <Switch disabled={!is_editable} />
                  </Field>
                }
              />
            </Section>
          );
        }}
      </Field>
    </Wrapper>
  );
};
export default PCM;
